import React, { useCallback, useEffect, useRef, useState } from "react";
import UserEngagement from "./UserEngagement/UserEngagement";
import NormalButton from "./NormalVariant/NormalButton";


const LockedComponent = ({
    openLinkedInLogin,
    handlerCertified,
  }) => {


    return (
        <div className="mt-6 w-full">
          <UserEngagement openLinkedInLogin={openLinkedInLogin} />
          <div className="mt-2"  >
            <NormalButton handlerCertified={handlerCertified} />
          </div>
        </div>
    )
}

export default LockedComponent;